import React, { useEffect } from "react";

import { requiresAuth } from "pages/UserAuth/requiresAuthHOC";
import { useSelector } from "react-redux";
import {
  isAdminUser,
  isLicenseExpired,
  isTrialLicense,
} from "ee/selectors/organizationSelectors";

import LicenseCheckPageNonAdmin from "./Components/LicenseCheckPageNonAdmin";
import LicenseCheckPageFreshInstance from "./Components/LicenseCheckPageFreshInstance";
import { getAppsmithConfigs } from "ee/configs";
import LicenseCheckPageExpiredTrial from "./Components/LicenseCheckPageExpiredTrial";
import LicenseCheckPageExpiredPaid from "./Components/LicenseCheckPageExpiredPaid";
import AILicenceExpiredPage from "./Components/AILicenceExpiredPage";
import ChoosePlan from "../CloudBillingWelcome/ChoosePlan";
import { useIsCloudBillingEnabled } from "hooks";
import { getIsAiAgentFlowEnabled } from "ee/selectors/aiAgentSelectors";
const { intercomAppID } = getAppsmithConfigs();

function LicenseCheckPage() {
  const isAdmin = useSelector(isAdminUser);
  const isExpired = useSelector(isLicenseExpired);
  const isTrial = useSelector(isTrialLicense);

  const isCloudBillingEnabled = useIsCloudBillingEnabled();
  const isAiAgentFlowEnabled = useSelector(getIsAiAgentFlowEnabled);

  function hideIntercomLauncher(val: boolean) {
    if (intercomAppID && window.Intercom) {
      window.Intercom("boot", {
        app_id: intercomAppID,
        hide_default_launcher: val,
      });
    }
  }

  useEffect(function hideIntercomEffect() {
    hideIntercomLauncher(false);

    return () => hideIntercomLauncher(true);
  }, []);

  if (!isAdmin) {
    return <LicenseCheckPageNonAdmin />;
  } else {
    if (isExpired) {
      if (isAiAgentFlowEnabled) {
        return <AILicenceExpiredPage />;
      } else if (isTrial) {
        return <LicenseCheckPageExpiredTrial />;
      } else {
        return <LicenseCheckPageExpiredPaid />;
      }
    }

    return isCloudBillingEnabled || isAiAgentFlowEnabled ? (
      <ChoosePlan />
    ) : (
      <LicenseCheckPageFreshInstance />
    );
  }
}

export default requiresAuth(LicenseCheckPage);
